import playersInTourny from './dataPlayersInTournys';
import confederationQualifiers from './dataConfederationQualifiers';
import teams from './dataTeams';
import matches from './dataMatches';
import qualifyingHistory from './dataQualifyingHistory';
import * as utilities from './utilities';
import players from './dataPlayers';
import clubs from './dataClubs';

/*
 * @param theRound
 * @returns {string}
 */

function setAttributesFalse() {
    //set all attributes to false
    for (let theLayerIndex = 1; theLayerIndex <= settings.layerIndices.lastMainLayerIndex; theLayerIndex++) {
        //remove all attributes
        if (settings.globals.layerParameters[theLayerIndex].auxillaryAttributes) {
            for (const attribute of settings.globals.layerParameters[theLayerIndex].auxillaryAttributes) {
                document.querySelector('html').setAttribute(attribute, 'false');
            }
        }
    }
}

function getPointsForASingleTeam(theTeamID) {
    // all matches
    let wins = 0;
    let losses = 0;
    let ties = 0;
    let theMatches = settings.globals.currentMatches.filter(
        (m) => (m.teamOneID === theTeamID || m.teamTwoID === theTeamID) && m.matchCompleted
    );
    for (const aMatch of theMatches) {
        if (aMatch.teamOneID === theTeamID) {
            if (aMatch.teamOneScore > aMatch.teamTwoScore) wins++;
            else if (aMatch.teamOneScore < aMatch.teamTwoScore) losses++;
            else ties++;
        } else {
            if (aMatch.teamOneScore < aMatch.teamTwoScore) wins++;
            else if (aMatch.teamOneScore > aMatch.teamTwoScore) losses++;
            else ties++;
        }
    }
    return {
        wins: wins,
        losses: losses,
        ties: ties,
    };
}

function getRoundName(theRound) {
    let theText = '';
    if (theRound === 1.1) {
        theText = 'Group' + '&nbsp' + 'Stage,' + '&nbsp' + 'Round' + '&nbsp' + '1';
    } else if (theRound === 1.2) {
        theText = 'Group' + '&nbsp' + 'Stage,' + '&nbsp' + 'Round' + '&nbsp' + '2';
    } else if (theRound === 1.3) {
        theText = 'Group' + '&nbsp' + 'Stage,' + '&nbsp' + 'Round' + '&nbsp' + '3';
    } else if (theRound === 1.4) {
        theText = 'Group' + '&nbsp' + 'Stage,' + '&nbsp' + 'Round' + '&nbsp' + '4';
    } else if (theRound === 1.5) {
        theText = 'Group' + '&nbsp' + 'Stage,' + '&nbsp' + 'Round' + '&nbsp' + '5';
    } else if (theRound === 2) {
        theText = 'Round' + '&nbsp' + 'Of' + '&nbsp' + 'Thirty-Two';
    } else if (theRound === 3) {
        theText = 'Round' + '&nbsp' + 'Of' + '&nbsp' + 'Sixteen';
    } else if (theRound === 4) {
        theText = 'Qtr-Final';
    } else if (theRound === 5) {
        theText = 'Semi-Final';
    } else if (theRound === 6) {
        theText = 'Final';
    } else if (theRound === 7) {
        theText = 'Winner';
    }
    return theText;
}

/**
 * @param anEntityID
 * @returns {string}
 */
function getProperEntityName(anEntityID) {
    let theReturnText = '';
    if (anEntityID === 'TBD') theReturnText = 'TBD';
    else {
        let theEntity = settings.fifaEntities.find((o) => o.ID === anEntityID);

        if (theEntity === undefined) {
            utilities.myErrorReport(
                'location 90 ' + 'unable to find fifa entity: ' + anEntityID,
                settings.misc.majorError
            );
            theReturnText = undefined;
        } else {
            if (theEntity.type === 'club') theReturnText = theEntity.displayName;
            else if (theEntity.type === 'geographic') theReturnText = theEntity.name;
        }
    }
    return theReturnText;
}

/**
 * @param
 * @returns
 */
function getRegionBounds(whichLayer) {
    if (whichLayer === settings.layerIndices.MWCVideosLayerIndex) return settings.map.regionBounds.worldBounds;
    else if (whichLayer === settings.layerIndices.WWCVideosLayerIndex) return settings.map.regionBounds.worldBounds;
    else if (whichLayer === settings.layerIndices.MEuroVideosLayerIndex) return settings.map.regionBounds.europeBounds;
    else if (whichLayer === settings.layerIndices.greatMPlayerVideosLayerIndex)
        return settings.map.regionBounds.worldBounds;
    else if (whichLayer === settings.layerIndices.greatWPlayerVideosLayerIndex)
        return settings.map.regionBounds.worldBounds;
    else {
        //looking at layer within a tourny
        return settings.map.regionBounds[settings.globals.currentTourny.regionBounds];
    }
}

/**
 * @param anEntityID
 * @returns {string}
 */
function getEntityCentroid(anEntityID) {
    let theEntity = settings.fifaEntities.find((o) => o.ID === anEntityID);
    let theReturn = '';
    if (theEntity === undefined) {
        utilities.myErrorReport('location 100 ' + 'unable to find fifa entity', settings.misc.majorError);
    } else {
        theReturn = [theEntity.latitude, theEntity.longitude];
    }
    return theReturn;
}

/**
 * @param theEntityID
 * find the ID of the group that the entity belongs to
 */
function getEntityGroupID(theEntityID) {
    let theTeam = settings.globals.currentTeams.find((o) => o.ID === theEntityID);
    if (theTeam === undefined) {
        return 'Z'; //as a way to indicate entity not in any group
    } else return theTeam.groupID;
}


async function mySynchFetch(theCall) {
    let response = await fetch(theCall);
    let theResult = await response.json();
    return theResult;
}
async function pullNecessaryAPIData() {
    let promise = null;
    let theTourny = settings.globals.currentTourny;

    if (theTourny.dataSources.matchesInPHPGeneratedJSONFile) {
        promise = mySynchFetch('./phpGeneratedJSON/' + theTourny.tournyID + '/' + theTourny.tournyID + 'Matches.json').then((theJson) => {
            settings.globals.currentMatches = theJson[0].matches;
        });
        await promise;
    }

    if (theTourny.dataSources.clubsInAllClubsInUseFile) {
         promise = mySynchFetch('./phpGeneratedJSON/allClubsInUse.json').then((theJson) => {//for new tournaments, clubs are allClubsInUse.json (for now November 2025)
                settings.globals.clubs = theJson[0].clubs;
            });

            await promise;
        
    }

    if (theTourny.dataSources.playersInAllPlayersFile) {
        if (theTourny.playerListReady) {
            promise = mySynchFetch('./phpGeneratedJSON/allPlayers.json').then((theJson) => {//for new tournaments, players are allPlayers.json (for now November 2025)
                settings.globals.players = theJson[0].players;
            });

            await promise;
        }
    }

    if (theTourny.dataSources.playersInTournyInPHPGeneratedJSONFile) {
        if (theTourny.playerListReady) {
            promise = mySynchFetch('./phpGeneratedJSON/' + theTourny.tournyID + '/' + theTourny.tournyID + 'PlayersInTourny.json').then(
                (theJson) => {
                    settings.globals.currentPlayersInTourny = theJson[0].players;
                }
            );
            await promise;
        }
    }

    if (theTourny.dataSources.teamsInPHPGeneratedJSONFile) {
        promise = mySynchFetch('./phpGeneratedJSON/' + theTourny.tournyID + '/' + theTourny.tournyID + 'TeamIDs.json').then((theJson) => {
            settings.globals.currentTeams = theJson[0].teams;
        });
        await promise;
    }

    if (theTourny.dataSources.confederationQualifiersInPHPGeneratedJSONFile) {
        promise = mySynchFetch('./phpGeneratedJSON/' + theTourny.tournyID + '/' + theTourny.tournyID + 'ConfederationQualifiers.json').then(
            (theJson) => {
                settings.globals.currentTeams = theJson[0].teams; // this looks wrong becuase it is putting teams into currentTeams (10/25/23) but it was like this before
            }
        );
        await promise;
    }

    if (theTourny.dataSources.qualifyingHistoryInPHPGeneratedJSONFile) {
        promise = mySynchFetch('./phpGeneratedJSON/' + theTourny.tournyID + '/' + theTourny.tournyID + 'Qualifying.json').then((theJson) => {
            settings.globals.currentTeams = theJson[0].teams;
        });
        await promise;
    }
}

async function pullCorrectData(tournyID) {
    settings.globals.currentTourny = settings.tournys.find((k) => k.tournyID === tournyID);
    settings.globals.currentGroups = [];
    for (const aGroupID of settings.globals.currentTourny.groupIDs) {
        let theGroup = settings.groups.find((k) => k.groupID === aGroupID);
        settings.globals.currentGroups.push(theGroup);
    }

    if (!settings.globals.currentTourny.dataSources.matchesInPHPGeneratedJSONFile) {
        settings.globals.currentMatches = matches.find((k) => k.tournyID === tournyID).matches;
    }

    if (!settings.globals.currentTourny.dataSources.playersInAllPlayersFile) {
        settings.globals.players = players;
    }

    if (!settings.globals.currentTourny.dataSources.clubsInAllClubsInUseFile) {
        settings.globals.clubs = clubs;
    }

    if (!settings.globals.currentTourny.dataSources.playersInTournyInPHPGeneratedJSONFile) {
        settings.globals.currentPlayersInTourny = playersInTourny.find((k) => k.tournyID === tournyID).players;
    }

    if (!settings.globals.currentTourny.dataSources.teamsInPHPGeneratedJSONFile) {
        settings.globals.currentTeams = teams.find((k) => k.tournyID === tournyID).teams;
    }

    if (!settings.globals.currentTourny.dataSources.confederationQualifiersInPHPGeneratedJSONFile) {
        const foundQualifiers = confederationQualifiers.find(
            (k) => k.tournyID === tournyID
        );
        settings.globals.currentConfederationQualifiers = foundQualifiers ? foundQualifiers.qualifiers : [];
    }

    if (!settings.globals.currentTourny.dataSources.qualifyingHistoryInPHPGeneratedJSONFile) {
        //only gets used for certain tournys but should never be undefined
        const foundHistory = qualifyingHistory.find((k) => k.tournyID === tournyID);
        settings.globals.currentQualifyingHistory = foundHistory ? foundHistory.matches : [];
    }

    await pullNecessaryAPIData();
    //settings.globals.currentRankings = rankings.find((k) => k.tournyID === tournyID).rankings;

    if (
        settings.globals.currentMatches === undefined ||
        settings.globals.currentTeams === undefined ||
        settings.globals.currentPlayersInTourny === undefined ||
        settings.globals.currentConfederationQualifiers === undefined ||
        settings.globals.currentQualifyingHistory === undefined ||
        settings.globals.currentTourny === undefined ||
        settings.globals.currentRankings === undefined
    ) {
        utilities.myErrorReport('location 110 ' + 'unable to find basic tourny info', settings.misc.majorError); //should never happen
    }

    // Auto-fill bracket slots for knockout matches after first round
    // This only modifies matches in memory, does not write to files
    autoFillBracketSlots();
}


function getTournyRankingIndex(entityID) {
    let tempArray = [];
    for (let team of settings.globals.currentTeams) {
        tempArray.push([getWorldRank(team.ID), team.ID]);
    }
    tempArray.sort((a, b) => utilities.mySort(a, b)); // sort by ranking
    let rankIndex = tempArray.findIndex((m) => m[1] === entityID);
    if (rankIndex === undefined) {
        utilities.myErrorReport(
            'location 700, error looking for team ranking index for ' + entityID,
            settings.misc.majorError
        );
        return undefined;
    } else {
        return rankIndex;
    }
}

function getWorldRank(entityID) {

}

/*
 * Most of the data for this site is either built or retrieved as needed.  However, the group data is an exception.  This function
 * tallies all the results for each of the groups and stores it when the tourny  is loaded.
 * @returns doesn't return anything. It just builds the table for group results.
 */
function tallyResults() {
    for (const theTeam of settings.globals.currentTeams) {
        theTeam.groupStageWins = 0;
        theTeam.groupStageLosses = 0;
        theTeam.groupStageTies = 0;
        theTeam.groupStagePoints = 0;
        theTeam.groupStageGoalsFor = 0;
        theTeam.groupStageGoalsAgainst = 0;
        theTeam.groupStageGoalDifferential = 0;
    }
    for (let k = 0; k < settings.globals.currentMatches.length; k++) {
        if (settings.globals.currentMatches[k].stage < 2) {
            // check that it is a group match
            let teamOne = settings.globals.currentTeams.find(
                (o) => o.ID === settings.globals.currentMatches[k].teamOneID
            );
            let teamTwo = settings.globals.currentTeams.find(
                (o) => o.ID === settings.globals.currentMatches[k].teamTwoID
            );
            if (teamOne === undefined || teamTwo === undefined)
                utilities.myErrorReport(
                    'location 120 ' +
                    'team not found when tallying group results, teamOneID: ' +
                    settings.globals.currentMatches[k].teamOneID +
                    'teamTwoID: ' +
                    settings.globals.currentMatches[k].teamTwoID,
                    settings.misc.majorError
                );
            else {
                if (settings.globals.currentMatches[k].matchCompleted) {
                    if (
                        settings.globals.currentMatches[k].teamOneScore ===
                        settings.globals.currentMatches[k].teamTwoScore
                    ) {
                        // tie
                        teamOne.groupStageTies += 1;
                        teamTwo.groupStageTies += 1;
                        teamOne.groupStagePoints += 1;
                        teamTwo.groupStagePoints += 1;
                    } else if (
                        settings.globals.currentMatches[k].teamOneScore >
                        settings.globals.currentMatches[k].teamTwoScore
                    ) {
                        // teamOne won
                        teamOne.groupStageWins += 1;
                        teamTwo.groupStageLosses += 1;
                        teamOne.groupStagePoints += 3;
                    } else {
                        // teamTwo won
                        teamOne.groupStageLosses += 1;
                        teamTwo.groupStageWins += 1;
                        teamTwo.groupStagePoints += 3;
                    }
                    teamOne.groupStageGoalsFor += settings.globals.currentMatches[k].teamOneScore;
                    teamTwo.groupStageGoalsFor += settings.globals.currentMatches[k].teamTwoScore;
                    teamOne.groupStageGoalsAgainst += settings.globals.currentMatches[k].teamTwoScore;
                    //notice the team order reverses here, intentionally
                    teamTwo.groupStageGoalsAgainst += settings.globals.currentMatches[k].teamOneScore;
                    teamOne.groupStageGoalDifferential = teamOne.groupStageGoalsFor - teamOne.groupStageGoalsAgainst;
                    teamTwo.groupStageGoalDifferential = teamTwo.groupStageGoalsFor - teamTwo.groupStageGoalsAgainst;
                }
            }
        }
    }
}

/*
 * This function determines the confederation to which the entity belongs.
 * @param entityID
 * @returns {confederationID}
 */
function getConfederationOfEntity(entityID) {
    let theFifaEntity = settings.fifaEntities.find((q) => q.ID === entityID);
    if (theFifaEntity === undefined) {
        utilities.myErrorReport('location 130 ' + ' entity not found: ' + entityID, settings.misc.majorError);
        return undefined;
    } else {
        //get the confederation
        let theConfederation = settings.confederations.find((q) => q.confederationID === theFifaEntity.confederationID);
        if (theConfederation === undefined) {
            utilities.myErrorReport(
                'location 140 ' + ' confederation not found: ' + entityID + ' ' + theFifaEntity.confederationID,
                settings.misc.majorError
            );
        }
        return theConfederation;
    }
}

/*
 * This function figures out how many players are entering, leaving or playing within each confederation to play on
 * their club team.
 * It tallys all the results for all the confederations at once and doesn't return anything.
 */

function getCorrectTimeFormat(theTime, includeTimezone = true) {
    function convertToTwelveHourClock(theTime) {
        theTime = theTime.split(':'); // convert to array

        // fetch
        let hours = Number(theTime[0]);
        let minutes = Number(theTime[1]);

        // calculate
        let timeValue;

        if (hours > 0 && hours <= 12) {
            timeValue = '' + hours;
        } else if (hours > 12) {
            timeValue = '' + (hours - 12);
        } else if (hours === 0) {
            timeValue = '12';
        }

        timeValue += minutes < 10 ? ':0' + minutes : ':' + minutes; // get minutes
        timeValue += hours >= 12 ? ' PM' : ' AM'; // get AM/PM

        // show
        return timeValue;
    }
    let returnText = theTime;
    if (theTime) {
        if (settings.globals.currentTourny.timeFormat === 'military') {
            //do nothing because the times are in JSON in military format
        } else if (settings.globals.currentTourny.timeFormat === 'USA') {
            returnText = convertToTwelveHourClock(theTime);
            if (includeTimezone) {
                returnText += ' EST';
            }
        } else utilities.myErrorReport('location 1001 timeFormat incorrect ', settings.misc.majorError);
    }
    return returnText;
}

function tallyPlayersComingToFromConfederations() {
    let continueOn = true;
    let temp = '';
    let theClub = '';
    let playersHomeEntityID = '';
    let playersClubEntityID = '';
    let playersHomeConfederation = '';
    let playersClubConfederation = '';
    settings.globals.withinConfederationSwoops = [];
    settings.globals.leavingConfederationSwoops = [];
    settings.globals.enteringConfederationSwoops = [];
    for (const confederation of settings.confederations) {
        confederation.playersLeavingTotal = 0;
        confederation.playersEnteringTotal = 0;
        confederation.playersStayingWithinTotal = 0;
    }

    let k = 0;
    while (k < settings.globals.currentPlayersInTourny.length) {
        continueOn = true; // for each player find the entity where they compete internationally
        let homeEntityID = settings.globals.currentPlayersInTourny[k].playsForID,
            playersHomeConfederation = getConfederationOfEntity(settings.globals.currentPlayersInTourny[k].playsForID);
        if (playersHomeConfederation === undefined) {
            utilities.myErrorReport(
                'location 150 ' +
                'players home confederation not found: ' +
                settings.globals.currentPlayersInTourny[k].playerID,
                settings.misc.majorError
            );
            continueOn = false;
        }
        if (continueOn) {
            // continueOn to find the club of the player
            theClub = settings.globals.clubs.find(
                (p) => p.clubID === settings.globals.currentPlayersInTourny[k].clubID
            );
            if (theClub === undefined) {
                //some players might not have a club (especially women)
                continueOn = false;
            }
        }
        if (continueOn) {
            // continueOn to find the entity of the player's club
            playersClubEntityID = theClub.clubLocationID;
            playersClubConfederation = getConfederationOfEntity(theClub.clubLocationID);
            if (playersClubConfederation === undefined) {
                utilities.myErrorReport(
                    'location 170 ' + 'confederation for club not found: ' + theClub.clubLocationID,
                    settings.misc.majorError
                );
                continueOn = false;
            }
        }
        if (continueOn) {
            // tally the result
            if (playersHomeConfederation.confederationID === playersClubConfederation.confederationID) {
                playersHomeConfederation.playersStayingWithinTotal =
                    playersHomeConfederation.playersStayingWithinTotal + 1;
                if (settings.globals.currentPlayersInTourny[k].playsForID !== theClub.clubLocationID) {
                    //player plays within the same confederation but outside home country, we will add a swoopy arrow
                    temp = settings.globals.withinConfederationSwoops.find(
                        (m) =>
                            m[0] === playersHomeConfederation.confederationID &&
                            m[1] === homeEntityID &&
                            m[2] === playersClubEntityID
                    );
                    if (temp === undefined) {
                        settings.globals.withinConfederationSwoops.push([
                            playersHomeConfederation.confederationID,
                            homeEntityID,
                            playersClubEntityID,
                            1, // first entry
                        ]);
                    } else {
                        temp[3] += 1; // increment the counter
                    }
                }
            } else {
                //player plays outside his confederation, we will add a entering swoopy arrow in the format of from  to
                playersHomeConfederation.playersLeavingTotal = playersHomeConfederation.playersLeavingTotal + 1;
                playersClubConfederation.playersEnteringTotal = playersClubConfederation.playersEnteringTotal + 1;
                temp = settings.globals.leavingConfederationSwoops.find(
                    (m) =>
                        m[0] === playersHomeConfederation.confederationID &&
                        m[1] === homeEntityID &&
                        m[2] === playersClubEntityID
                );
                if (temp === undefined) {
                    settings.globals.leavingConfederationSwoops.push([
                        playersHomeConfederation.confederationID,
                        homeEntityID,
                        playersClubEntityID,
                        1, // first entry
                    ]);
                } else {
                    temp[3] += 1; // increment the counter
                }
                temp = settings.globals.enteringConfederationSwoops.find(
                    (m) =>
                        m[0] === playersClubConfederation.confederationID &&
                        m[1] === homeEntityID &&
                        m[2] === playersClubEntityID
                );
                if (temp === undefined) {
                    settings.globals.enteringConfederationSwoops.push([
                        playersClubConfederation.confederationID,
                        homeEntityID,
                        playersClubEntityID,
                        1, // first entry
                    ]);
                } else {
                    temp[3] += 1; // increment the counter
                }
            }
        }
        k++;
    }
}

/*
 * This function figures out how many players are entering a given entity to play on
 * a club within that entity. The number is calculated as the total number of players on the team
 * minus the number who do not enter from elsewhere.
 * @param baseEntityID is the ID of the country of interest
 * @returns {count}
 */
function countPlayersOnClubsInOtherEntities(baseEntityID) {
    let theEntityIDS = [];
    let theCount = 0;
    let thePlayers = settings.globals.currentPlayersInTourny.filter((m) => m.playsForID === baseEntityID);
    for (let k = 0; k < thePlayers.length; k++) {
        // for each player find their club
        let theClub = settings.globals.clubs.find((p) => p.clubID === thePlayers[k].clubID);
        if (theClub === undefined) {
            //some players may not have a club (especially women)
        } else {
            theEntityIDS.push(theClub.clubLocationID);
        }
    }
    let basePlayers = theEntityIDS.filter((v) => v === baseEntityID);
    if (basePlayers === undefined) {
        utilities.myErrorReport(
            'location 190 ' + 'when searching entities yielded undefined for entity: ' + baseEntityID,
            settings.misc.dataNotFoundOK
        );
    } else {
        theCount = theEntityIDS.length - basePlayers.length;
    }
    return theCount;
}

/*
 * This function figures out how many players are many players play for clubs within that entity.
 * These can be players from outside or within the entity.  There is no limit to this number. For example England typically has
 * has about 80 players.
 * @param entityID is the ID of the country of interest
 * @returns {count}
 */

function countPlayersOnClubsInEntityFromOtherEntities(entityID) {
    let theCount = 0;
    let theClubs = settings.globals.clubs.filter((p) => p.clubLocationID === entityID);
    if (theClubs === undefined) {
        utilities.myErrorReport(
            'location 200 ' + 'undefined encountered when searching for clubs in:' + entityID,
            settings.misc.majorError
        );
    } else {
        let oneClubPlayersInEnity = '';
        theCount = 0;
        for (let k = 0; k < theClubs.length; k++) {
            oneClubPlayersInEnity = settings.globals.currentPlayersInTourny.filter(
                (z) => z.clubID === theClubs[k].clubID
            );
            for (let j = 0; j < oneClubPlayersInEnity.length; j++) {
                if (
                    oneClubPlayersInEnity[j].playsForID !== entityID //don't count players from the country that play for clubs in the country
                )
                    theCount++;
            }
        }
    }
    return theCount;
}

function getProperClubName(theClub) {
    let returnText = null;
    if (theClub) {
        if (settings.globals.currentTourny.tournyID === 'MWC2014') returnText = theClub.clubName2014;
        else if (settings.globals.currentTourny.tournyID === 'MWC2018') returnText = theClub.clubName2018;
        else if (settings.globals.currentTourny.tournyID === 'MEuro2021') {
            if (theClub.clubName2021) returnText = theClub.clubName2021;
            else if (theClub.clubName2018) returnText = theClub.clubName2018;
            else returnText = theClub.clubName2014;
        } else returnText = theClub.clubName;
    }
    return returnText;
}

function chkConfedInTourny(confedID) {
    // Use allowedConfederationIDs array if available (new approach)
    if (settings.globals.currentTourny.allowedConfederationIDs) {
        return settings.globals.currentTourny.allowedConfederationIDs.includes(confedID);
    }

    // Fallback for backward compatibility (old approach)
    return (
        confedID === settings.globals.currentTourny.confederationID ||
        0 === settings.globals.currentTourny.confederationID
    ); //0 means world tourny
}

function countQualifiedTeamsFromConfed(desiredID) {
    let count = 0;
    for (const aTeam of settings.globals.currentTeams) {
        let theEntity = settings.fifaEntities.find((k) => k.ID === aTeam.ID);
        if (theEntity === undefined)
            utilities.myErrorReport(
                'location 205 ' + 'undefined encountered when searching for fifa entity:' + aTeam.ID,
                settings.misc.majorError
            );
        else if (theEntity.confederationID === desiredID) count++;
    }
    return count;
}

function getProperPlayerName(thePlayer, theTeamID) {
    if (
        (theTeamID === 'BRA' &&
            (settings.globals.currentTourny.tournyID === 'WWC2019' ||
                settings.globals.currentTourny.tournyID === 'WWC2015')) ||
        (theTeamID === 'POR' && settings.globals.currentTourny.tournyID === 'MEuro2021')
    )
        //this is a hack because some players didnt have last names in their profiles nor shirtNames
        return thePlayer.firstName;
    else
        return thePlayer[settings.globals.currentTourny.nameDisplayType];
}

function getTeamLogoFromAPI(theTeamID) {
    return settings.fifaEntities.find((k) => k.ID === theTeamID).logoPath;
}

function getRoundOfInterestFromLayer(stageLayer) {
    if (!settings.globals.currentTourny) {
        return null;
    }
    const indices = settings.layerIndices;
    const format = settings.globals.currentTourny.scheduleFormat;

    if (stageLayer === indices.groupStageOverallLayerIndex) {
        return 1;
    }

    if (
        format === 'threeRoundsToThirtyTwoKnockOut' &&
        indices.r32KnockOutLayerIndex &&
        stageLayer === indices.r32KnockOutLayerIndex
    ) {
        return 2;
    }
    if (stageLayer === indices.r16LayerIndex) return 3;
    if (stageLayer === indices.r8LayerIndex) return 4;
    if (stageLayer === indices.r4LayerIndex) return 5;
    if (stageLayer === indices.r2LayerIndex) return 6;
    return null;
}

/**
 * Checks if all group stage matches are completed
 * @param {Array} matches - Array of match objects
 * @returns {boolean} - True if all group stage matches are completed
 */
function areGroupStagesComplete(matches) {
    if (!matches || matches.length === 0) {
        return false;
    }

    const groupStageMatches = matches.filter(m => m.stage < 2);

    // If there are no group stage matches, consider it complete (tournament might not have group stages)
    if (groupStageMatches.length === 0) {
        return true;
    }

    // Check if all group stage matches are completed
    return groupStageMatches.every(m => m.matchCompleted === true);
}

/**
 * Determines the winner of a match
 * @param {Object} match - Match object
 * @returns {string|null} - Team ID of the winner, or null if match not completed or tied
 */
function getMatchWinner(match) {
    if (!match || !match.matchCompleted) {
        return null;
    }

    // In knockout rounds, there should be no ties (penalty shootouts handle ties)
    if (match.teamOneScore > match.teamTwoScore) {
        return match.teamOneID;
    } else if (match.teamTwoScore > match.teamOneScore) {
        return match.teamTwoID;
    } else {
        // If scores are equal and no penalty shootout, return null
        // (This shouldn't happen in knockout rounds, but handle it gracefully)
        return null;
    }
}

/**
 * Finds a match record with the two given teams in a specific stage
 * If multiple matches exist with these teams, returns the one that happened later
 * @param {Array} allMatches - Array of all match objects
 * @param {string} team1ID - First team ID
 * @param {string} team2ID - Second team ID
 * @param {number} stage - Stage number to filter matches (only look for matches in this exact stage)
 * @returns {Object|null} - Match object, or null if not found
 */
function findMatchWithTeams(allMatches, team1ID, team2ID, stage) {
    if (!allMatches || !team1ID || !team2ID) {
        return null;
    }

    // Find all matches in this stage with these teams (could be in either order)
    const matchingMatches = allMatches.filter(m => {
        // Must be in the exact stage
        if (m.stage !== stage) {
            return false;
        }
        // Check if teams match (could be in either order)
        return (m.teamOneID === team1ID && m.teamTwoID === team2ID) ||
            (m.teamOneID === team2ID && m.teamTwoID === team1ID);
    });

    if (matchingMatches.length === 0) {
        return null;
    }

    if (matchingMatches.length === 1) {
        return matchingMatches[0];
    }

    // Multiple matches found - return the one that happened later
    matchingMatches.sort((a, b) => {
        if (b.year !== a.year) return b.year - a.year;
        if (b.month !== a.month) return b.month - a.month;
        if (b.day !== a.day) return b.day - a.day;
        if (a.time && b.time) {
            return b.time.localeCompare(a.time);
        }
        return 0;
    });

    // Return the most recent match (first in sorted array)
    return matchingMatches[0];
}

/**
 * Gets the two previous round slots that feed into a current slot
 * @param {string} currentSlot - Current bracket slot (e.g., 'r8-1', 'r4-2')
 * @param {string} scheduleFormat - Tournament schedule format
 * @returns {Array<string>|null} - Array of two previous round slots, or null if invalid
 */
function getPreviousRoundSlots(currentSlot, scheduleFormat) {
    if (!currentSlot || !scheduleFormat) {
        return null;
    }

    const isThreeRoundsToThirtyTwo = scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
    const isThreeRoundsToEight = scheduleFormat === 'threeRoundsToEightKnockOut';
    const isFiveRoundsToEight = scheduleFormat === 'fiveRoundsToEightKnockOut';

    // Handle r32 → r16 progression (only for threeRoundsToThirtyTwoKnockOut)
    if (isThreeRoundsToThirtyTwo && currentSlot.startsWith('r16-')) {
        const matchNum = parseInt(currentSlot.split('-')[1]);
        const slot1Num = (matchNum - 1) * 2 + 1;
        const slot2Num = (matchNum - 1) * 2 + 2;
        return [`r32-${slot1Num}`, `r32-${slot2Num}`];
    }

    // Handle r16 → r8 progression
    if (currentSlot.startsWith('r8-')) {
        const matchNum = parseInt(currentSlot.split('-')[1]);
        if (isThreeRoundsToThirtyTwo) {
            // For threeRoundsToThirtyTwoKnockOut: r8 looks back to r16
            const slot1Num = (matchNum - 1) * 2 + 1;
            const slot2Num = (matchNum - 1) * 2 + 2;
            return [`r16-${slot1Num}`, `r16-${slot2Num}`];
        } else if (!isThreeRoundsToEight && !isFiveRoundsToEight) {
            // For threeRoundsToSixteenKnockOut: r8 looks back to r16
            const slot1Num = (matchNum - 1) * 2 + 1;
            const slot2Num = (matchNum - 1) * 2 + 2;
            return [`r16-${slot1Num}`, `r16-${slot2Num}`];
        }
        // For threeRoundsToEightKnockOut and fiveRoundsToEightKnockOut, r8 is the first round
        // so there are no previous rounds to look back to
        return null;
    }

    // Handle r8 → r4 progression
    if (currentSlot.startsWith('r4-')) {
        const matchNum = parseInt(currentSlot.split('-')[1]);
        const slot1Num = (matchNum - 1) * 2 + 1;
        const slot2Num = (matchNum - 1) * 2 + 2;
        return [`r8-${slot1Num}`, `r8-${slot2Num}`];
    }

    // Handle r4 → r2 progression (Final)
    if (currentSlot === 'r2') {
        return ['r4-1', 'r4-2'];
    }

    return null;
}

/**
 * Automatically fills bracket slots for knockout matches after the first round
 * This function modifies matches in memory only - does not write to files
 * @returns {void}
 */
function autoFillBracketSlots() {
    // Skip if no tournament or matches loaded
    if (!settings.globals.currentTourny || !settings.globals.currentMatches) {
        return;
    }

    // Skip if tournament has no bracket
    if (settings.globals.currentTourny.bracketVariant === 'none') {
        return;
    }

    // Check if group stages are complete
    if (!areGroupStagesComplete(settings.globals.currentMatches)) {
        return;
    }

    const scheduleFormat = settings.globals.currentTourny.scheduleFormat;
    const matches = settings.globals.currentMatches;

    // Identify the first knockout round based on schedule format
    const isThreeRoundsToThirtyTwo = scheduleFormat === 'threeRoundsToThirtyTwoKnockOut';
    const isThreeRoundsToEight = scheduleFormat === 'threeRoundsToEightKnockOut';
    const isFiveRoundsToEight = scheduleFormat === 'fiveRoundsToEightKnockOut';

    // Determine which rounds need to be auto-filled
    let roundsToProcess = [];

    if (isThreeRoundsToThirtyTwo) {
        // Process: r16, r8, r4, r2 (r32 is the first round, manually entered)
        roundsToProcess = [
            { slotPattern: 'r16-', stage: 3 },
            { slotPattern: 'r8-', stage: 4 },
            { slotPattern: 'r4-', stage: 5 },
            { slotPattern: 'r2', stage: 6 }
        ];
    } else if (isThreeRoundsToEight || isFiveRoundsToEight) {
        // Process: r4, r2 (r8 is the first round, manually entered)
        roundsToProcess = [
            { slotPattern: 'r4-', stage: 5 },
            { slotPattern: 'r2', stage: 6 }
        ];
    } else {
        // Default: threeRoundsToSixteenKnockOut
        // Process: r8, r4, r2 (r16 is the first round, manually entered)
        roundsToProcess = [
            { slotPattern: 'r8-', stage: 4 },
            { slotPattern: 'r4-', stage: 5 },
            { slotPattern: 'r2', stage: 6 }
        ];
    }

    // Process each round
    for (const round of roundsToProcess) {
        // Determine how many matches should be in this round
        let numMatches;
        if (round.slotPattern === 'r2') {
            numMatches = 1;
        } else if (round.slotPattern === 'r4-') {
            numMatches = 2;
        } else if (round.slotPattern === 'r8-') {
            numMatches = 4;
        } else if (round.slotPattern === 'r16-') {
            numMatches = 8;
        } else if (round.slotPattern === 'r32-') {
            numMatches = 16;
        } else {
            continue;
        }

        // Process each bracket slot in this round
        for (let slotNum = 1; slotNum <= numMatches; slotNum++) {
            // Determine the bracket slot name
            let bracketSlot;
            if (round.slotPattern === 'r2') {
                bracketSlot = 'r2';
            } else {
                bracketSlot = round.slotPattern + slotNum;
            }

            // Get previous round slots that feed into this bracket slot
            const previousSlots = getPreviousRoundSlots(bracketSlot, scheduleFormat);

            if (!previousSlots || previousSlots.length !== 2) {
                // This is the first round or invalid slot, skip
                continue;
            }

            // Find the two previous round matches
            const prevMatch1 = matches.find(m => m.bracketSlot === previousSlots[0]);
            const prevMatch2 = matches.find(m => m.bracketSlot === previousSlots[1]);

            if (!prevMatch1 || !prevMatch2) {
                // Previous matches not found, skip
                continue;
            }

            // Get winners from previous matches
            const winner1 = getMatchWinner(prevMatch1);
            const winner2 = getMatchWinner(prevMatch2);

            if (!winner1 || !winner2) {
                // Not both matches completed yet, skip
                continue;
            }

            // Check if this bracket slot is already assigned to any match
            // Skip if the slot is already filled (manually or by previous code run)
            const existingMatchWithSlot = matches.find(m => m.bracketSlot === bracketSlot);
            if (existingMatchWithSlot) {
                // This slot is already filled, skip it
                continue;
            }

            // Find the match record in this stage with these two teams
            const actualMatch = findMatchWithTeams(matches, winner1, winner2, round.stage);

            if (!actualMatch) {
                // Match not found, skip
                continue;
            }

            // Skip if this match already has a different bracketSlot assigned
            // (This shouldn't happen if the above check worked, but just in case)
            if (actualMatch.bracketSlot && actualMatch.bracketSlot !== 'none' && actualMatch.bracketSlot !== bracketSlot) {
                continue;
            }

            // Determine expected team order: winner1 should be teamOne, winner2 should be teamTwo
            const expectedTeamOne = winner1;
            const expectedTeamTwo = winner2;

            // Check if the actual match has teams in the same order or reversed
            const teamsInSameOrder = actualMatch.teamOneID === expectedTeamOne &&
                actualMatch.teamTwoID === expectedTeamTwo;
            const teamsReversed = actualMatch.teamOneID === expectedTeamTwo &&
                actualMatch.teamTwoID === expectedTeamOne;

            if (!teamsInSameOrder && !teamsReversed) {
                // Teams don't match - this shouldn't happen, skip
                continue;
            }

            // Update the match record with bracket slot and correct data
            actualMatch.bracketSlot = bracketSlot;

            if (teamsInSameOrder) {
                // Teams are in the same order - ensure bracketSlot is set correctly
                // (scores are already correct, but we may need to update other fields)
            } else {
                // Teams are reversed - swap the scores and team positions
                actualMatch.teamOneID = expectedTeamOne;
                actualMatch.teamTwoID = expectedTeamTwo;
                const tempScore = actualMatch.teamOneScore;
                actualMatch.teamOneScore = actualMatch.teamTwoScore;
                actualMatch.teamTwoScore = tempScore;

                // Swap alt text and comments too
                const tempAltText = actualMatch.teamOneAltText;
                actualMatch.teamOneAltText = actualMatch.teamTwoAltText;
                actualMatch.teamTwoAltText = tempAltText;

                const tempComments = actualMatch.teamOneComments;
                actualMatch.teamOneComments = actualMatch.teamTwoComments;
                actualMatch.teamTwoComments = tempComments;
            }
        }
    }
}

export {
    getRoundName,
    getProperEntityName,
    getEntityCentroid,
    getEntityGroupID,
    getProperClubName,
    getTournyRankingIndex,
    getWorldRank,
    getConfederationOfEntity,
    pullCorrectData,
    tallyResults,
    tallyPlayersComingToFromConfederations,
    countPlayersOnClubsInEntityFromOtherEntities,
    countPlayersOnClubsInOtherEntities,
    getRegionBounds,
    chkConfedInTourny,
    countQualifiedTeamsFromConfed,
    getProperPlayerName,
    getTeamLogoFromAPI,
    getCorrectTimeFormat,
    getPointsForASingleTeam,
    setAttributesFalse,
    getRoundOfInterestFromLayer,
};
